import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Constants } from 'src/app/app.constants';
import { OptionsSource } from 'src/app/core/core.models';
import { UtilityService } from 'src/app/core/utility.service';
import { ValueLabel } from 'src/app/shared/base/base.models';
import { ProductClassification } from 'src/app/shared/product-classification/product-classification.models';
import { ProductClassificationService } from 'src/app/shared/product-classification/product-classification.service';
import { Municipality } from '../../municipalities/municipalities.models';
import { MunicipalitiesService } from '../../municipalities/municipalities.service';
import { DashboardCustomerType, DashboardOrderDateType, DashboardParam } from '../dashboard.models';
import * as moment from 'moment';
import { DeliveryLocation } from '../../business-partners/business-partners.models';
import { BusinessPartnersService } from '../../business-partners/business-partners.service';
import { PointOfSale } from '../../points-of-sale/points-of-sale.models';
import { PointsOfSaleService } from '../../points-of-sale/points-of-sale.service';
import { CompanyType } from '../../companies/companies.models';

@Component({
  selector: 'app-dashboard-filters',
  templateUrl: './dashboard-filters.component.html',
  styleUrls: ['./dashboard-filters.component.scss']
})
export class DashboardFiltersComponent implements OnInit {
  @Input('periodFrom') periodFrom: Date | string;
  @Input('periodTo') periodTo: Date | string;
  @Input('company') company: any;
  @Output() closeFilterDrawerEvent = new EventEmitter();
  @Output() filterEvent = new EventEmitter();
  // Date type
  DashboardOrderDateType = DashboardOrderDateType;
  orderDateTypes: ValueLabel[] = [];
  selectedDateFilter: DashboardOrderDateType = DashboardOrderDateType.ORDER_DATE;
  // Customer type
  DashboardCustomerType = DashboardCustomerType;
  selectedCustomerFilter: DashboardCustomerType = null;
  showCustomerType: boolean = true;
  // Municipalities
  selectedMunicipalities: Municipality[] = [];
  municipalities: OptionsSource;
  municipalitiesUrl: string = `${Constants.contextPath}/municipalities`;
  showMunicipalities: boolean = true;
  // Categories
  selectedCategories: ProductClassification[] = [];
  productMerchandiseGroups: OptionsSource;
  productMerchandiseGroupsUrl: string = `${Constants.contextPath}/product-merchandise-groups`;
  showCategories: boolean = true;
  // Delivery locations
  selectedDeliveryLocations: DeliveryLocation[] = [];
  deliveryLocations: OptionsSource;
  deliveryLocationsUrl: string = `${Constants.contextPath}/delivery-locations`;
  showDeliveryLocations: boolean = true;
  // Points of sale
  selectedPointsOfSale: PointOfSale[] = [];
  pointsOfSale: OptionsSource;
  pointsOfSaleUrl: string = `${Constants.contextPath}/point-of-sales`;
  showPointsOfSale: boolean = true;

  CompanyType = CompanyType;

  constructor(
    private pointsOfSaleService: PointsOfSaleService,
    private businessPartnersService: BusinessPartnersService,
    private municipalitiesService: MunicipalitiesService,
    private productClassificationService: ProductClassificationService,
    public utilityService: UtilityService
  ) { }

  ngOnInit(): void {
    this.checkCompanyType();
    this.prepareLookupData();
  }

  ngOnChanges(changes) {
    this.checkCompanyType();
  }

  checkCompanyType() {
    switch(this.company?.companyType) {
      case CompanyType[CompanyType.B2C]:
        this.showCustomerType = true;
        this.showMunicipalities = true;
        this.showCategories = true;
        this.showDeliveryLocations = false;
        this.showPointsOfSale = false;
        break;
      case CompanyType[CompanyType.B2B]:
        this.showCustomerType = false;
        this.showMunicipalities = false;
        this.showCategories = true;
        this.showDeliveryLocations = true;
        this.showPointsOfSale = true;
        break;
      case CompanyType[CompanyType.ALL]:
        this.showCustomerType = true;
        this.showMunicipalities = true;
        this.showCategories = true;
        this.showDeliveryLocations = true;
        this.showPointsOfSale = true;
        break;
      default:
        this.showCustomerType = false;
        this.showMunicipalities = false;
        this.showCategories = false;
        this.showDeliveryLocations = false;
        this.showPointsOfSale = false;
        break;

    }

  }

  prepareLookupData() {
    this.municipalities = this.municipalitiesService.getMunicipalitiesLookup();
    this.productMerchandiseGroups = this.productClassificationService.getAttributesByType('MERCHANDISE_GROUP', false);
    this.deliveryLocations = this.businessPartnersService.getDeliveryLocationsOptions();
    this.pointsOfSale = this.pointsOfSaleService.getPointsOfSaleOptions();
  }

  closeFilterDrawer() {
    this.closeFilterDrawerEvent.emit();
  }

  applyFilters() {
    let params = new DashboardParam();
    params.dashboardCustomerType = this.selectedCustomerFilter;
    params.orderDateType = this.selectedDateFilter;
    params.municipalities = this.selectedMunicipalities.map(m => m.id);
    params.productMerchandiseGroups = this.selectedCategories.map(p => p.id);
    params.deliveryLocations = this.selectedDeliveryLocations.map(d => d.id);
    params.pointsOfSale = this.selectedPointsOfSale.map(p => p.id);
    params.periodFrom = this.periodFrom != null ? moment(this.periodFrom).format('YYYY-MM-DD') : null;
    params.periodTo = this.periodTo != null ? moment(this.periodTo).format('YYYY-MM-DD') : null;
    this.filterEvent.emit(params);
  }

  clearFilters() {
    let params = new DashboardParam();
    this.selectedDateFilter = DashboardOrderDateType.ORDER_DATE;
    this.selectedCustomerFilter = null;
    this.selectedCategories = [];
    this.selectedMunicipalities = [];
    this.selectedDeliveryLocations = [];
    this.selectedPointsOfSale = [];
    this.periodFrom = null;
    this.periodTo = null;
    this.filterEvent.emit(params);
  }

  onMunicipalitiesSelectionChanged(event) {
    this.selectedMunicipalities = event;
  }

  onProductMerchandiseGroupChanged(event) {
    this.selectedCategories = event;
  }

  onDeliveryLocationsChanged(event) {
    this.selectedDeliveryLocations = event;
  }

  onPointsOfSaleChanged(event) {
    this.selectedPointsOfSale = event;
  }

  selectDateFilter(dateFilter: DashboardOrderDateType) {
    this.selectedDateFilter = dateFilter;
  }

  selectCustomerFilter(customerFilter: DashboardCustomerType) {
    this.selectedCustomerFilter = customerFilter;
  }
}
